

class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'bootScene' });
  }

  preload() {}

  create() {}

  update(time, dt) {
    console.log('update boot');
    // how to change to another scene
    // this.scene.manager.switch('bootScene', 'gameScene')
  }
}

export { BootScene };


//////////////////
// WEBPACK FOOTER
// ./src/scenes/boot.js
// module id = 1380
// module chunks = 0